import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogConfirmation } from '../../../../../components/dialog/confirmation';
import { DeviceConnectionState } from '../../../../../data-access/gql-types/graphql';
import { useDevicesAndChannels } from '../../../hooks/devices-and-channels';
import { useChannelsStateStore } from '../../../store/channels-state';
import { DeviceType } from '../../../types';
import { checkDeviceStatus } from '../../../utils/devices/status';
import { useConfiguration } from '../../channel-configuration/hooks/use-configuration';
import './index.scss';

type UpdateDevicesProps = {
  devicesToUpdate: DeviceType[];
};

export const UpdateDevices: React.FC<UpdateDevicesProps> = ({ devicesToUpdate }) => {
  const { t } = useTranslation('device-list');
  const { t: tc } = useTranslation('common');
  const [showUpdateAllDialog, setShowUpdateAllDialog] = useState<boolean>(false);
  const { updateDevices } = useConfiguration({ devices: devicesToUpdate });
  const { channelState } = useChannelsStateStore();
  const { deviceChannelsById } = useDevicesAndChannels();
  const isUpdateAllEnabled = devicesToUpdate
    .filter((device) => device.payload.isUpdateAvailable)
    .filter((device) => {
      const deviceChannels = deviceChannelsById(device.id);
      return checkDeviceStatus(deviceChannels, channelState, DeviceConnectionState.Connected);
    }).length;

  const onUpdateAllCancel = () => setShowUpdateAllDialog(false);

  const onUpdateAll = () => {
    updateDevices();
    setShowUpdateAllDialog(false);
  };

  return (
    <>
      <button className="devices-update" disabled={!isUpdateAllEnabled} onClick={() => setShowUpdateAllDialog(true)}>
        {t('updateAll')}
      </button>
      <DialogConfirmation
        show={showUpdateAllDialog}
        setShow={setShowUpdateAllDialog}
        header={t('updateAllContent')}
        primaryBtnText={t('update')}
        secondaryBtnText={tc('buttons.cancel')}
        primaryBtnAction={onUpdateAll}
        secondaryBtnAction={onUpdateAllCancel}
      />
    </>
  );
};
